import { hasAnyAccess } from 'helper/access-permission';
import { useEffect, useState } from 'react';
import { UseAuth } from 'hook/auth-hook';
import { RestCrud } from 'service/api/rest/rest-crud-usecase';
import { ConfigurationEntity } from '../../../@types/entity/configuration-entity';
import ConfigurationPage from 'pages/layout/settings/configuration-page';
import { SelectOptionInterface } from '../../../@types/entity/interface/select-option-interface';
import ErrorNotAuthorizedPage from 'pages/layout/error/error-not-authorized-page';
import { HeaderNavegationList } from 'helper/adapter/headerNavigation/header-navegation-adapter';
import { getEnv } from 'helper/window-helper';

export const ConfigurationFactory: React.FC = () => {
  const ENDPOINT_CRUD = getEnv('REACT_APP_END_POINT_CONFIGURATION');

  const [marksOptions, setMarksOptions] = useState<SelectOptionInterface[]>([]);

  const loadFileVersionOptions: SelectOptionInterface[] = [
    { label: 'V1', value: 'V1' },
    { label: 'V2', value: 'V2' },
    { label: 'V9', value: 'V9' },
  ];

  const fieldForOverlappingSparePartsEqualToZeroOptions: SelectOptionInterface[] = [
    { label: 'Preço de Reposição', value: 'PRECO_REPOSICAO' },
    { label: 'Preço de Venda', value: 'PRECO_VENDA' },
    { label: 'Preço de Garantia', value: 'PRECO_GARANTIA' },
    { label: 'Custo Médio', value: 'CUSTO_MEDIO' },
  ];

  /** VERIFICA PERMISSAO DE ACESSO */
  const { loggedUserData } = UseAuth();
  const [showScreen, updateShowScreen] = useState<boolean>(false);
  useEffect(() => {
    const roleScreen = HeaderNavegationList.filter((header) => header.navTitle === 'Configurações')[0].navItem.filter(
      (item) => item.title === 'Cadastrar Configuração'
    )[0].access;

    if (hasAnyAccess(loggedUserData?.access, roleScreen)) {
      updateShowScreen(true);
      findMarksOptions();
    }
  }, [loggedUserData]);

  const findMarksOptions = async () => {
    await new RestCrud(ENDPOINT_CRUD! + '/marcas')
      .Get()
      .then((response) => {
        setMarksOptions(
          response.body.map((marca: { id: Number; siglaMarca: string }) => {
            return { label: marca.siglaMarca, value: marca.id };
          })
        );
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  return (
    <>
      {showScreen ? (
        <ConfigurationPage
          modelMethods={{
            create: async function (model: ConfigurationEntity): Promise<boolean> {
              const response = await new RestCrud(ENDPOINT_CRUD!).Post(model);
              return response.body;
            },
            edit: async function (model: ConfigurationEntity, id: number): Promise<boolean> {
              const response = await new RestCrud(`${ENDPOINT_CRUD!}/${id}`).Put(model);
              return response.body;
            },
            remove: async function (id: number): Promise<boolean> {
              const response = await new RestCrud(ENDPOINT_CRUD!).Delete(id);
              return response.body;
            },
            getAll: async function (): Promise<ConfigurationEntity[]> {
              const response = await new RestCrud(ENDPOINT_CRUD!).Get();
              return response.body;
            },
            get: async function (): Promise<ConfigurationEntity> {
              const response = await new RestCrud(ENDPOINT_CRUD!).Get();
              return response.body;
            },
            getById: async function (id: number): Promise<ConfigurationEntity> {
              const response = await new RestCrud(ENDPOINT_CRUD!).GetById(id);
              return response.body;
            },
          }}
          marksOptions={marksOptions}
          loadFileVersionOptions={loadFileVersionOptions}
          fieldForOverlappingSparePartsEqualToZeroOptions={fieldForOverlappingSparePartsEqualToZeroOptions}
        />
      ) : (
        <ErrorNotAuthorizedPage />
      )}
    </>
  );
};
